// extracted by mini-css-extract-plugin
export default {"price":"C8-z","onSale":"D8-z","msrpLabelPrice":"E8-z","msrpLabel":"F8-z","originalPrice":"G8-z","percentOff":"H8-z"};